import type { ColumnsType } from 'antd/es/table';

export const columnsEstoque: ColumnsType = [
  {
    title: "Rack",
    dataIndex: "TouroRack",
    key: "TouroRack",
  },
  {
    title: "Produto",
    dataIndex: "ProdutoNome",
    key: "ProdutoNome",
  },
  {
    title: "Tipo",
    dataIndex: "ProdutoTipo",
    key: "ProdutoTipo",
  },
  {
    title: "Raça",
    dataIndex: "TouroRaca",
    key: "TouroRaca",
  },
  {
    title: "Semen",
    dataIndex: "TouroSemenTipo",
    key: "TouroSemenTipo",
  },
  {
    title: "Botijão",
    dataIndex: "Botijao",
    key: "Botijao",
  },
  {
    title: "Caneca",
    dataIndex: "Caneca",
    key: "Caneca",
  },
  {
    title: "Qtde",
    dataIndex: "Quantidade",
    key: "Quantidade",
    align: "right",
    width: 60,
  },
];
